import React from 'react';
import Icon from '../jo-components/ui/icon/icon';
import { classnames } from '../../utils/classnames';
import './toggleViewList.css';

export default function ToggleViewList({toggleList = true, setToggleList = () => {}}) {

    return (
        <div className='neo-toggle-view-contaner'>
            <div className={classnames('neo-toggle-view-icon', {'active' : toggleList})} onClick={() => setToggleList(true)}>
                <Icon name='list' size='huge'/>
            </div>
            <div className={classnames('neo-toggle-view-icon', {'active' : !toggleList})} onClick={() => setToggleList(false)}>
                <Icon name='grid' size='huge'/>
            </div>
        </div>
    )
}